export const KEY_CODES = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  HOME: 'Home',
  SPACE: ' ',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  TAB: 'Tab'
};

export const AllSelectableElements =
  'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"]), [tabindex="0"]';
